import { render, staticRenderFns } from "./PublicationsListReadonly.vue?vue&type=template&id=75ee10e2&scoped=true&"
import script from "./PublicationsListReadonly.vue?vue&type=script&lang=js&"
export * from "./PublicationsListReadonly.vue?vue&type=script&lang=js&"
import style0 from "./PublicationsListReadonly.vue?vue&type=style&index=0&id=75ee10e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ee10e2",
  null
  
)

export default component.exports